export default __webpack_public_path__ + "static/media/info.5bb1fb5c.svg";